"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var JudicialScales = function JudicialScales(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M3.983 13.32l2.08-4.68a.157.157 0 00-.107-.214 2.947 2.947 0 01-1.289-.676l-.085-.089a.312.312 0 01.004-.441l.447-.438a.313.313 0 01.443.004l.08.084c.41.315.92.472 1.436.442.49-.034.972-.137 1.433-.305a13.51 13.51 0 012.502-.554.233.233 0 00.207-.204c.079-.707.231-1.403.455-2.077a.434.434 0 01.822 0 10.2 10.2 0 01.455 2.077.233.233 0 00.207.204c.85.105 1.687.29 2.501.555.462.167.944.27 1.434.304a2.154 2.154 0 001.436-.442l.08-.083a.313.313 0 01.443-.005l.446.438a.312.312 0 01.005.441l-.085.09c-.366.329-.81.56-1.289.675a.157.157 0 00-.107.214l2.08 4.68c.071.16.108.333.108.508v.428a.62.62 0 01-.302.536 5.202 5.202 0 01-5.02 0 .62.62 0 01-.303-.536v-.428c0-.175.037-.348.108-.508l2.036-4.581a.156.156 0 00-.125-.218 8.634 8.634 0 01-1.305-.317c-.684-.22-1.386-.38-2.097-.482a.16.16 0 00-.18.156v7.872a2.5 2.5 0 002.5 2.5c.173 0 .313.14.313.313v.625c0 .172-.14.312-.313.312H8.564a.312.312 0 01-.313-.313v-.625c0-.172.14-.312.313-.312a2.5 2.5 0 002.5-2.5V7.878a.16.16 0 00-.18-.156 12.8 12.8 0 00-2.097.482c-.426.14-.862.245-1.305.317a.156.156 0 00-.125.218l2.036 4.581c.071.16.108.333.108.508v.428a.62.62 0 01-.302.536 4.955 4.955 0 01-2.51.646 4.955 4.955 0 01-2.51-.646.62.62 0 01-.303-.536v-.428c0-.175.037-.348.108-.508zm2.626-2.832l-1.14 2.566a.362.362 0 00.33.508h1.777a.361.361 0 00.33-.508l-1.14-2.566a.086.086 0 00-.157 0zm9.815 3.075h1.777a.362.362 0 00.33-.509l-1.14-2.566a.086.086 0 00-.157 0l-1.14 2.566a.362.362 0 00.33.508z"
  }));
};

var _default = (0, _react.forwardRef)(JudicialScales);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(JudicialScales, "JudicialScales", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/JudicialScales.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/JudicialScales.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();